import {
  Component,
  Input,
  Output,
  ViewChild,
  EventEmitter,
  OnInit,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { IonicSelectableComponent } from "ionic-selectable";
import { DataReference } from "src/app/interfaces/helpers";
import { Installation } from "src/app/interfaces/installation";
import { InstallationsService } from "src/app/services/installations/installations.service";

@Component({
  selector: "selectable-installation",
  templateUrl: "./selectable-installation.component.html",
  styleUrls: ["./selectable-installation.component.scss"],
})
export class selectableInstallationComponent implements OnInit {
  @ViewChild("selectableInstallation")
  selectableInstallation: IonicSelectableComponent;
  installations: Installation[] = [];
  @Input() installationsData: DataReference[] = [];
  @Output() selection: EventEmitter<Installation[]> = new EventEmitter();
  selectedInstallations: Installation[] = [];

  installationSelected = new FormControl();
  constructor(private installationServ: InstallationsService) {}

  ngOnInit(): void {
    let selectInstallations:Installation[] = [];
    this.installationServ.getInstallations().subscribe((res) => {
      this.installationServ.installationsData = res;
      this.installations = this.installationServ.installationsData;

      this.installations.forEach((installation) => {
        if (
          this.installationsData.find(
            (inst) => inst.ref.id === installation.id
          ) !== undefined
        ) {
          selectInstallations.push(installation);
        }
      });
      this.installationSelected.setValue(selectInstallations);
      this.selectedInstallations.push(...selectInstallations);
    });
  }

  saveInstallation(): void {
    this.selectableInstallation.confirm();
    this.selectableInstallation.close();

    this.selection.emit(this.selectedInstallations);
  }

  installationsSearch(event: {
    component: IonicSelectableComponent;
    value: any;
  }) {
    // console.log(event);

    const text = event["text"].trim().toLowerCase();
    event.component.startSearch();
    if (!text) {
      // Close any running subscription.
      event.component.items = this.installationServ.installationsData;;
      event.component.endSearch();
      return;
    }
    this.filterInstallations(text).subscribe((res) => {
      this.installations = res;
      event.component.items = res;
      event.component.endSearch();
    });
  }

  filterInstallations(filter: string) {
    return this.installationServ.filterInstallations(filter);
  }

  installationsClear(event: {
    component: IonicSelectableComponent;
    value: any;
  }) {
    // console.log(event)
  }

  getIconColor(installation: Installation) {
    if (installation.disabled) {
      return "iron";
    }
    switch (installation.type[0]) {
      case "residential":
        return "primary";
      case "company":
        return "sapphire";
      case "parking":
        return "parking";
      case "store":
        return "buttercup";
      case "restaurant":
        return "buttercup";
      case "school":
        return "campus";
    }
  }
}
